import { get } from 'lodash';
import { USER } from '../../reducer';

export const getName = (state) => {
  return get(state[USER], 'userInfo.data.wholeName');
};

export const getPhoneNumber = (state) => {
  return get(state[USER], 'userInfo.data.phone');
};

export const getHasData = (state) => {
  return !get(state[USER], 'hasData');
};
